export enum CommonFilters {
  ResetAllFilters = 'htfw',
  ResetAllAndApply = 'WpbN',
}
